<template>
	<div>
		<div class="h-container">
			<main-header class="i-h" :child="child"></main-header>
			<div class="content">
				<div class="content-nav flex-sb">
					<div class="title col-center">提交参赛作品记录</div>
					<div class="right col-center">
						<div class="search">
							<el-input style="width: 100%;" placeholder="输入关键字搜索" prefix-icon="el-icon-search"
								v-model="queryForm.key_words">
							</el-input>
						</div>
						<div class="search-btn sub-btn">
							<el-button type="primary" @click="search">搜索</el-button>
						</div>
					</div>
				</div>
				<div class="table">
					<div class="table-inner">
						<el-table stripe :data="tableData" style="width: 100%" v-loading="loading">
							<el-table-column type="index" label="序号" width="60px">
							</el-table-column>
							<el-table-column prop="name" label="项目名称">
							</el-table-column>
							<el-table-column prop="project.title" label="参赛信息">
							</el-table-column>
							<el-table-column prop="school.name" label="项目申报学校">
							</el-table-column>
							<el-table-column prop="group.name" label="参赛组别">
							</el-table-column>
							<el-table-column prop="achievement.name" label="成果类型">
							</el-table-column>
							<el-table-column prop="teacher_name" label="第一指导教师姓名">
							</el-table-column>
							<el-table-column prop="team_principal_name" label="团队负责人姓名">
							</el-table-column>
							<el-table-column prop="team_principal_education" label="团队负责人学历">
							</el-table-column>
							<el-table-column prop="end_date" label="校赛评审结果">
								<template slot-scope="scope">
									<span :class="[['primary','primary','success'][scope.row.school_audit_status]]">{{['待评审','待评审','已评审'][scope.row.school_audit_status]}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="end_date" label="省赛评审结果">
								<template slot-scope="scope">
									<span :class="[['primary','primary','success'][scope.row.province_audit_status]]">{{['待评审','待评审','已评审'][scope.row.province_audit_status]}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="end_date" label="资格审核">
								<template slot-scope="scope">
									<span
										:class="[['primary','success','error','error'][scope.row.apply_audit_status]]">{{['审核中','通过','驳回','省赛驳回'][scope.row.apply_audit_status]}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="status" label="操作" width="120px">
								<template slot-scope="scope">
									<div class="col-center">
										<div><el-button type="text" @click="open(scope.row.id)">查看</el-button></div>
										<div class="line"
											v-if="scope.row.is_update == 1">
										</div>
										<div v-if="scope.row.is_update == 1">
											<el-button type="text" @click="editor(scope.row)">编辑</el-button>
										</div>
									</div>
									<div class="col-center">
										<div v-if="scope.row.is_update == 1">
											<el-button type="text" style="color:red"
												@click="delItem(scope.row)">删除</el-button>
										</div>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</div>

				</div>
				<div class="pages">
					<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:page-sizes="[5,10,20,50]" :page-size="queryForm.per_page"
						layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
				<div class="pages-small">
					<el-pagination @current-change="handleCurrentChange" layout="prev, pager, next" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		<review-detail ref="reviewDetail" v-model="dialogVisible" @close="dialogVisible = false"></review-detail>
		<review-submit ref="reviewSubmit" v-model="sdialogVisible" @close="sdialogVisible = false"
			@submit="submitReport"></review-submit>
	</div>
</template>

<script>
	import mainHeader from '@/components/main-header/main-header'
	import reviewDetail from './components/review-detail'
	import reviewSubmit from './components/review-submit'
	import {
		getHistoryList,
		deleteReport
	} from '@/common/api/history.js'
	import {
		submitReport
	} from '@/common/api/report.js'
	export default {
		name: '',
		props: {

		},
		components: {
			mainHeader,
			reviewDetail,
			reviewSubmit
		},
		data() {
			return {
				searchkey: '',
				queryForm: {
					page: 1,
					per_page: 10,
					key_words: ''
				},
				loading: true,
				total: 0,
				child: [],
				tableData: [],
				dialogVisible: false,
				sdialogVisible: false,
				detailId: '',
				audit_project_id: '',
				theme: []
			}
		},
		created() {
			this.getList()
		},
		mounted() {
			// 添加面包屑
			this.child = [{
				path: "/index",
				name: "Index",
				title: this.authority === 'expert' ? '参赛作品评审' : '首页'
			}]
		},
		methods: {
			async getList() {
				this.loading = true
				try {
					const {
						data
					} = await getHistoryList(this.queryForm)
					console.log(data)
					this.tableData = data.data
					this.total = Number(data.meta.pagination.total)
					this.loading = false
				} catch (e) {
					this.loading = false
					//TODO handle the exception
				}

			},
			handleSizeChange(e) {
				this.queryForm.page = 1
				this.queryForm.per_page = e
				this.getList()
			},
			handleCurrentChange(e) {
				console.log(e)
				this.queryForm.page = e
				this.getList()
			},
			search() {
				this.queryForm.page = 1
				this.getList()
			},
			open(id) {
				this.dialogVisible = true;
				this.$refs.reviewDetail.init(id)
			},
			editor(row) {
				this.sdialogVisible = true;
				this.audit_project_id = row.audit_project_id
				this.$refs.reviewSubmit.getDetail(row.id)
			},
			isEnd(date) {
				let end = new Date(date).getTime(),
					time = new Date().getTime()
				if (time > end) {
					return false
				} else {
					return true
				}
			},
			// 修改申报
			async submitReport(form) {
				form.audit_project_id = this.audit_project_id
				this.loading = true
				try {
					const {
						data
					} = await submitReport(form)
					this.$message.success('修改成功！')
					this.sdialogVisible = false;
					this.$refs.reviewSubmit.loading = false;
					this.getList()
				} catch (e) {
					this.loading = false
					this.$refs.reviewSubmit.loading = false;
					console.log(e)
					//TODO handle the exception
				}
			},
			// 删除申报
			delItem(row) {
				this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					this.loading = true
					try {
						const {
							data
						} = await deleteReport({
							item_apply_id: row.id
						})
						this.loading = false
						this.getList()
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
					} catch (e) {
						this.loading = false
						//TODO handle the exception
					}
				}).catch((e) => {
					console.log(e)
				});
			}
		}

	}
</script>

<style lang="scss" scoped>
	.h-container {
		width: 100vw;
		height: 100vh;
		background-color: #F7F7F7;
		display: flex;
		flex-direction: column;

		.i-h {
			flex-shrink: 0;
		}

		.content {
			flex-grow: 1;
			height: 0;
			margin: 0.625rem;
			border-radius: 0.375rem;
			background-color: white;
			display: flex;
			flex-direction: column;

			.content-nav {
				padding: 1.25rem;
				border-bottom: 1px solid #E7EBF0;
				flex-shrink: 0;

				.title {
					font-size: 1.5rem;
					font-weight: bold;
					position: relative;
					padding-left: 1.5rem;
				}

				.title::after {
					content: "";
					display: block;
					width: 0.25rem;
					height: 1rem;
					position: absolute;
					background-color: #4389E0;
					left: 0.625rem;
					top: 50%;
					margin-top: -8px;
				}

				.right {
					.search {
						padding: 0 4.375rem;
						width: 20rem;
					}

					.search-btn {
						padding: 0 0.625rem;
					}
				}
			}

			.table {
				height: 0;
				flex-grow: 1;
				overflow-y: auto;
				padding: 1.875rem 2.5rem;

				.primary {
					display: inline-block;
					background: #F0F7FF;
					padding: 0.375rem 0.875rem;
					color: #4389E0;
					font-size: 0.875rem;
					border-radius: 0.375rem;
				}

				.success {
					display: inline-block;
					padding: 0.375rem 0.875rem;
					background: #E8FAEB;
					color: #59DB69;
					font-size: 0.875rem;
					border-radius: 0.375rem;
				}

				.warning {
					display: inline-block;
					padding: 0.375rem 0.875rem;
					background: #f1ece6;
					color: #E6A23C;
					font-size: 0.875rem;
					border-radius: 0.375rem;
				}

				.silver {
					display: inline-block;
					padding: 0.375rem 0.875rem;
					background: #f7f7f7;
					color: #999999;
					font-size: 0.875rem;
					border-radius: 0.375rem;
				}


				.line {
					height: 14px;
					width: 1px;
					margin: 0 0.625rem;
					background-color: #D5D5D5;
				}

				::v-deep .el-table__header tr,
				::v-deep .el-table__header th {
					background-color: #F4F4F4;
				}

				::v-deep .el-table .el-table__header td.el-table__cell,
				::v-deep .el-table .el-table__header th.el-table__cell.is-leaf {
					border-bottom: 0 none;
				}
			}

			.pages {
				padding: 2.5rem;
				display: flex;
				justify-content: flex-end;
			}

			.pages-small {
				display: none;
			}
		}
	}

	// 响应式

	@media screen and (min-width: 1200px) {}

	@media screen and (min-width: 923px) and (max-width:1199px) {}

	@media screen and (min-width: 768px) and (max-width:922px) {}

	@media screen and (max-width: 922px) {
		.h-container {
			.content {
				.content-nav {
					display: block;

					.title {
						font-size: 1.125rem;
					}

					.right {
						.search {
							padding: 1.25rem 0 0;
							width: 100%;

							.el-input {
								width: auto;
								flex-grow: 1;

								::v-deep {
									.el-input {
										width: 100%;
									}
								}
							}
						}

						.sub-btn {
							padding: 1.25rem 0 0 1.25rem;
						}
					}
				}

				.group {
					flex-wrap: wrap;

					.item {
						width: 100%;
						margin: 0.625rem 0 !important;
					}
				}

				.pages {
					display: none;
				}

				.pages-small {
					display: block;
					padding: 1.25rem;

					::v-deep {
						.el-pagination {
							display: flex;
							justify-content: center;
							transform: scale(1.2);
						}
					}
				}

				.table {
					padding: 1.25rem;
					overflow-x: auto;

					.table-inner {
						width: 70rem;
					}
				}
			}

		}

	}
</style>